<script setup>
import Commons from '@/shared/utils/commons'
import GridList from '../others/GridList.vue'
import { ref } from 'vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import DishDetails from '../dishes/DishDetails.vue'
import Events from '@/events/events'

const cols = [
  {
    name: 'Titre',
    id: 'title',
    value(el) {
      return el.title
    },
  },
  {
    name: 'Restaurant',
    id: 'storeName',
    value(el) {
      return el.storeName
    },
  },
  {
    name: 'Catégorie',
    id: 'category',
    value(el) {
      return el.category
    },
  },
  {
    name: 'Prix',
    id: 'price',
    value(el) {
      return `${el.price} ${el.currency}`
    },
  },
  {
    name: 'Durée',
    id: 'cookDurationInMin',
    value(el) {
      return `${el.cookDurationInMin} min`
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = el
    },
    value() {},
  },
]

const detailData = ref(null)

function onDishUpdated() {
  Events.dispatch('refresh_list_dishes')
  detailData.value = null
}
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <GridList
      title="Plats"
      dataKey="dishes"
      hasSearch
      refreshOnEvents="refresh_list_dishes"
      :elClickHanler="(el)=>{
        detailData = el
      }"
      :cols="cols"
      :cardConfig="{
        imageField: 'principalImageUrl',
        titleField: 'title',
        subtitleField: 'storeName',
        descriptionField: 'description',
        statusField: 'isPublished',
        formatter: (val) => val ? 'Publié' : 'Non publié',
        extraFields: [
          { key: 'category', label: 'Catégorie' },
          { key: 'price', label: 'Prix', format: (v, el) => `${v} ${el.currency}` },
          { key: 'cookDurationInMin', label: 'Durée', format: (v) => `${v} min` },
        ],
      }"
      :gridCols="{ sm: 1, md: 2, lg: 2, xl: 3 }"
    ></GridList>
  </div>
  <SlideDetailView :isVisible="!!detailData" @hide="detailData = null">
    <DishDetails :dishData="detailData" @updated="onDishUpdated"></DishDetails>
  </SlideDetailView>
</template>
